import { useState } from 'react';
import './App.css';
import './WhatsNew.css';

const APP_STORE_URL = 'https://apps.apple.com/us/app/advanced-bowling-tracker/id6759532374';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.advancedbowlingtracker';
const TOURNAMENTS_URL = 'https://advancedbowlingtournaments.com';

function AppLogo({ className }) {
  return <img className={className} src={process.env.PUBLIC_URL + '/logo192.png'} alt="" aria-hidden="true" />;
}

// Named glyphs for the real (v1.5 to v1.7) release notes, which come from the
// in-app What's New catalog. Anything unmapped falls back to a checkmark.
const ICONS = {
  envelope: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 8l9 6 9-6" /></>,
  location: <><path d="M12 2C8 2 5 5 5 9c0 5 7 13 7 13s7-8 7-13c0-4-3-7-7-7z" /><circle cx="12" cy="9" r="2.4" /></>,
  'chart.bar': <path d="M4 19V5M4 19h16M8 16V9m4 7V6m4 10v-4" />,
  'chart.line': <><path d="M4 19V5M4 19h16" /><path d="M7 15l3-4 3 2 5-6" /></>,
  'chart.dots': <><path d="M4 19V5M4 19h16" /><circle cx="9" cy="14" r="1.3" fill="currentColor" stroke="none" /><circle cx="13" cy="10" r="1.3" fill="currentColor" stroke="none" /><circle cx="17" cy="12" r="1.3" fill="currentColor" stroke="none" /></>,
  bell: <><path d="M6 16v-5a6 6 0 0112 0v5l2 2H4z" /><path d="M10 20a2 2 0 004 0" /></>,
  drop: <path d="M12 3s6 6.5 6 10a6 6 0 01-12 0c0-3.5 6-10 6-10z" />,
  'chart.pie': <><circle cx="12" cy="12" r="9" /><path d="M12 3v9h9" /></>,
  tray: <><path d="M12 3v10m0 0l-4-4m4 4l4-4" /><path d="M4 15v3a2 2 0 002 2h12a2 2 0 002-2v-3" /></>,
  binoculars: <><path d="M6 4h3l1 4M18 4h-3l-1 4" /><circle cx="6.5" cy="14" r="3.5" /><circle cx="17.5" cy="14" r="3.5" /><path d="M10 12h4" /></>,
  road: <path d="M6 3v18M18 3v18M12 4v3m0 4v3m0 4v3" />,
  people: <path d="M16 11a4 4 0 10-4-4 4 4 0 004 4zM8 11a4 4 0 10-4-4 4 4 0 004 4zm0 2c-2.7 0-8 1.3-8 4v3h8m8-7a11 11 0 00-1 .1" />,
  percent: <><path d="M19 5L5 19" /><circle cx="7.5" cy="7.5" r="2.5" /><circle cx="16.5" cy="16.5" r="2.5" /></>,
  trophy: <><path d="M7 4h10v4a5 5 0 01-10 0z" /><path d="M12 13v4M9 21h6" /></>,
  search: <><circle cx="11" cy="11" r="7" /><path d="M21 21l-4-4" /></>,
  number: <><rect x="3" y="3" width="18" height="18" rx="3" /><path d="M9 8v8M15 8v8M7 11h10M7 15h10" /></>,
  ipad: <><rect x="4" y="3" width="16" height="18" rx="3" /><path d="M9 18h6" /></>,
  broadcast: <><circle cx="12" cy="12" r="2" fill="currentColor" stroke="none" /><path d="M8.5 8.5a5 5 0 000 7M15.5 15.5a5 5 0 000-7" /><path d="M5.5 5.5a9 9 0 000 13M18.5 18.5a9 9 0 000-13" /></>,
  house: <><path d="M4 11l8-7 8 7" /><path d="M6 10v10h12V10" /></>,
  bag: <><path d="M5 8h14l-1 12H6z" /><path d="M9 8V6a3 3 0 016 0v2" /></>,
  star: <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.7-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z" />,
  scope: <><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="3" /><path d="M12 2v3M12 19v3M2 12h3M19 12h3" /></>,
  gauge: <><path d="M4 17a8 8 0 1116 0" /><path d="M12 17l4.6-4.6" /><circle cx="12" cy="17" r="1.4" fill="currentColor" stroke="none" /></>,
  'stack.plus': <><rect x="3" y="7" width="11" height="12" rx="2" /><path d="M7 4h6a2 2 0 012 2" /><path d="M19 13v6M16 16h6" /></>,
  tap: <><path d="M11 13V6a2 2 0 014 0v7" /><path d="M15 12a2 2 0 014 0v4a6 6 0 01-6 6h-1.6a4 4 0 01-3.2-1.6L5 15.5a1.9 1.9 0 012.8-2.5L10 15" /></>,
  wrench: <path d="M20 6.5a4.5 4.5 0 01-5.9 4.3L6.4 18.5a2 2 0 01-2.8-2.8l7.7-7.7A4.5 4.5 0 0117.5 4l-3 3 2.5 2.5 3-3z" />,
  check: <path d="M5 12l5 5L20 7" />,
};

function ChangeIcon({ name }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      {ICONS[name] || ICONS.check}
    </svg>
  );
}

// Real release notes (source of truth: the app's in-app What's New catalog).
const realReleases = [
  {
    version: '3.6', date: 'September 2026', title: 'Check Your Rev Rate',
    changes: [
      { icon: 'gauge', title: 'Rev Check (iOS only, Android coming soon)', body: 'Get your rev rate right from the app! Try out the beta and see your RPMs. Try with different balls for best results.' },
      { icon: 'scope', title: 'Spare systems', body: 'Need a spare routine? Now you can try out three different popular systems: Middle Arrow, 3-6-9, and Triax. Get guidance on where to stand and aim from your phone and watch.' },
      { icon: 'stack.plus', title: 'Add a game you forgot', body: 'Forget to start recording in the middle of league? Now the app will remind you and you can input the score you missed in a few simple steps.' },
      { icon: 'tap', title: 'Faster setup & scoring', body: 'We made some small improvements to new session and score recording screens to make things a bit faster for you.' },
      { icon: 'wrench', title: 'Polish and fixes', body: 'Bug fixes to reduce accidental score button presses on swipes. A new date range filter for stats and improvements to league management during new seasons.' },
    ],
  },
  {
    version: '3.5', date: 'August 2026', title: 'Practice your spares', current: true,
    changes: [
      { icon: 'scope', title: 'New Spare Drill', body: 'Set up any spare, pick a goal, and practice it as much as you want. Practice stays out of your league and tournament stats, and each session gets its own summary in Activity.' },
      { icon: 'search', title: 'League finding improvements', body: 'We made lots of improvements and fixed bugs with the league finding and importing process that should make it more reliable for you.' },
      { icon: 'trophy', title: 'Tournaments discovery improvements', body: 'Tournaments are now better sorted with filtering so you can easily see the tournaments coming soon near you.' },
      { icon: 'people', title: 'Social Age Gating improvements', body: 'Feeds, comments, follows, and live sharing are for bowlers 13 and older. If yours are disabled, the app now tells you why and gives you clear steps to enable them again.' },
      { icon: 'wrench', title: 'Polish and fixes', body: 'Spare tracking fixes, Home screen fixes, and live sharing fixes. Plus a faster scoresheet, more reliable league countdowns, and button responsiveness improvements for users with big histories.' },
    ],
  },
  {
    // Shipped 2026-08-02. Listed here as 3.4 because that is the version the App
    // Store and the in-app What's New both carry; the page used to number this
    // release 1.9 on a separate marketing track, which disagreed with what users
    // saw in Settings > About.
    version: '3.4', date: 'August 2026', title: 'Live with Friends',
    tagline: 'Version numbers now match the App Store, which is why this release follows 1.8.',
    changes: [
      { icon: 'broadcast', title: 'Live sharing is automatic', body: 'Live sharing now starts on its own when you begin a session, so your followers get notified and can watch you bowl. You can change who sees your live scores, or turn sharing off entirely in Settings.' },
      { icon: 'house', title: 'A more useful home screen', body: 'Rate the balls in your arsenal and discover tournaments near you.' },
      { icon: 'bag', title: 'Bag updates', body: 'Move a ball from your wishlist to your bag in one tap.' },
    ],
  },
  {
    version: '1.8', date: 'July 2026', title: 'Bowl together',
    changes: [
      { icon: 'broadcast', title: 'Watch friends bowl live', body: 'Get notified when friends start bowling, and follow along live.' },
      { icon: 'star', title: 'Community ball ratings', body: 'Rate the balls in your bag and see how your ratings compare to the community.' },
      { icon: 'scope', title: 'A simpler start to every session', body: 'Ball and targeting hints now appear right on the scoresheet instead of as pop-up sheets, so you can start bowling faster.' },
      { icon: 'wrench', title: 'Polish and fixes', body: 'More reliable league countdowns, Apple Watch improvements, and various bug fixes.' },
    ],
  },
  {
    version: '1.7', date: 'July 2026', title: 'Sign in with email',
    changes: [
      { icon: 'location', title: 'Find tournaments near you', body: 'The local tournament finder now ranks results nearest-first.' },
      { icon: 'drop', title: 'Redesigned oil pattern library', body: 'New interface for browsing and filtering oil patterns.' },
      { icon: 'chart.pie', title: 'Clearer plan usage', body: 'Free plan usage is now more clear so you know when limits reset.' },
      { icon: 'tray', title: 'Smoother league import', body: "We've improved the league import process to be faster and smoother." },
      { icon: 'envelope', title: 'Sign in with email', body: 'New users can sign up with email in addition to Apple or Google sign in options.' },
    ],
  },
  {
    version: '1.6', date: 'June 2026', title: 'Stats, teammates, and tournaments',
    changes: [
      { icon: 'chart.line', title: 'Redesigned Stats', body: 'The Stats section has been reworked into Scoring, Strikes, Spares, Forecasting (Pro), and History so you can find what you care about faster.' },
      { icon: 'binoculars', title: 'Discover tournaments', body: 'A new Discover section under Compete then Tournaments lets you browse over 1,000 upcoming local tournaments.' },
      { icon: 'road', title: 'Lane assignments', body: 'For supported leagues, see your upcoming lane assignments right on the league detail page and in your reminders.' },
      { icon: 'people', title: 'Teammate averages', body: "For supported leagues, you can now see all of your teammates' averages." },
      { icon: 'bell', title: 'League-day reminders', body: 'New league countdowns and reminders that you can tap to jump straight into recording your scores.' },
    ],
  },
  {
    version: '1.5', date: 'May 2026', title: 'Live stats',
    changes: [
      { icon: 'chart.dots', title: 'Compare balls visually', body: 'The Bag tab now has three unique views: Arsenal, Performance, and Compare. Pro users can use the new Compare view to chart owned and wishlisted balls by different metrics.' },
      { icon: 'percent', title: 'Live stats while you bowl', body: 'See your spare conversion rates and strike after strikes rates as you record your scores.' },
      { icon: 'trophy', title: 'End your leagues', body: 'End a league season from the league menu to save your final results, add notes about the season and see your progression.' },
      { icon: 'search', title: 'Faster alley search', body: 'It should be faster and more snappy to search for bowling alleys.' },
      { icon: 'number', title: 'Quick view of past games', body: 'Tap the icon next to your running score to quickly see your previous game scores and series total so far.' },
      { icon: 'ipad', title: 'iPad support', body: 'First version of native iPad friendly layouts for a better tablet experience.' },
    ],
  },
];

// Older releases. These summaries are drafted from the design handoff and can
// be refined against the real App Store version history any time.
const draftReleases = [
  {
    version: '1.4', date: 'May 2026', title: 'Smoother onboarding and league setup',
    changes: [
      { svg: <path d="M12 3l2 5h5l-4 3 1.5 5L12 18l-4.5 3L9 16 5 13h5z" />, title: 'New onboarding flow', body: 'First-time bowlers get a friendlier start.' },
      { svg: <path d="M4 7h16M4 12h16M4 17h10" />, title: 'Redesigned league setup', body: 'A step-by-step wizard makes adding your existing leagues much easier.' },
      { svg: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 9h18M9 4v16" /></>, title: 'More flexible frame editing', body: 'Tap any frame to fix a shot, swap the ball you used, or delete a shot.' },
    ],
    mini: [
      'Polished forms for adding a ball, logging past games, tournaments and editing sessions.',
      'Send feedback right from inside the app.',
      'Smarter teammate stats that include imported games for shared leagues.',
    ],
  },
  {
    version: '1.3', date: 'Apr 2026', title: 'Targets, redesigned scoring and sharing',
    changes: [
      { svg: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="4" /><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" /></>, title: 'First ball targets', body: 'Get a reminder of your target on your first ball each frame.' },
      { svg: <path d="M4 12v8h16v-8M16 6l-4-4-4 4M12 2v13" />, title: 'Redesigned sharing images', body: 'Cleaner score share images, plus a fresh activity feed.' },
    ],
    mini: [
      'Redesigned score recording view.',
      'See ball stats while choosing a ball during a game.',
      'Score importing fixes and 10th frame display fixes.',
    ],
  },
  {
    version: '1.2', date: 'Apr 2026', title: 'Better ball stats and bowler discovery',
    mini: [
      'Improved stats and views for your bowling balls, with ball layout settings.',
      'Better bowler search and discovery to find friends and teammates.',
      'Easier editing when you finish a session and need to change something.',
      'Redesigned game summary and end of session screens.',
    ],
  },
  {
    version: '1.1', date: 'Apr 2026', title: 'Friends, follows and polish',
    mini: [
      'Easier to find, follow and invite friends and teammates.',
      'Improved push notifications.',
      'Better editing of saved bowling sessions.',
    ],
  },
  {
    version: '1.0', date: 'Mar 2026', title: 'Hello, world', tagline: 'The first release of Advanced Bowling Tracker.',
    mini: [
      'Frame-by-frame scoring on iPhone and Apple Watch.',
      'Detailed stats, your ball arsenal, leagues and a social feed.',
    ],
  },
];

const releases = [...realReleases, ...draftReleases];

function Release({ release }) {
  const hasChanges = release.changes && release.changes.length > 0;
  return (
    <div className={`rel ${release.current ? 'cur' : ''}`}>
      <div className="meta">
        <span className={`ver ${release.current ? 'now' : ''}`}>v{release.version}</span>
        <div className="date">{release.comingSoon ? 'Coming Soon' : release.date}</div>
      </div>
      <span className="dot"></span>
      <div className="wn-card">
        <h2>{release.title}</h2>
        {release.tagline && <div className="tagline">{release.tagline}</div>}
        {hasChanges && (
          <div className="wn-changes">
            {release.changes.map((c) => (
              <div className="change" key={c.title}>
                <div className="ic">
                  {c.svg
                    ? <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">{c.svg}</svg>
                    : <ChangeIcon name={c.icon} />}
                </div>
                <div><b>{c.title}</b><p>{c.body}</p></div>
              </div>
            ))}
          </div>
        )}
        {release.mini && (
          <ul className={`mini ${hasChanges ? '' : 'mini-tight'}`}>
            {release.mini.map((m) => <li key={m}>{m}</li>)}
          </ul>
        )}
      </div>
    </div>
  );
}

function WhatsNew() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <div className="app whatsnew">
      {/* Nav */}
      <nav>
        <div className="wrap nav-in">
          <a href="/" className="logo"><AppLogo className="ball" /> Advanced Bowling Tracker</a>
          <div className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
            <a href="/#features" onClick={closeMenu}>Features</a>
            <a href="/#screens" onClick={closeMenu}>Screenshots</a>
            <a href="/#pricing" onClick={closeMenu}>Pricing</a>
            <a href="/guides">Guides</a>
            <a href="/whats-new" className="active">What's New</a>
            <a className="btn btn-red btn-sm" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">Download</a>
          </div>
          <button className="mobile-menu-btn" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      {/* Head */}
      <section className="wn-head">
        <div className="wn-wrap">
          <h1>What's new</h1>
        </div>
      </section>

      {/* Timeline */}
      <section className="timeline">
        <div className="wn-wrap">
          {releases.map((r) => <Release key={r.version} release={r} />)}
        </div>
      </section>

      {/* CTA */}
      <div className="wn-wrap">
        <div className="wn-cta">
          <h3>Detailed bowling tracking for everyone.</h3>
          <p>New bowlers get 1 month of Pro free.</p>
          {/* Both badges, not the user-agent routing used on interstitials: this
              page is as likely to be read on a desktop as on the phone the
              reader will actually install on. */}
          <div className="cta-row">
            <a className="appstore" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" fill="#fff" aria-hidden="true">
                <path d="M16.4 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9-.7 0-1.8-.8-3-.8-1.5 0-2.9.9-3.7 2.3-1.6 2.7-.4 6.7 1.1 8.9.7 1.1 1.6 2.3 2.8 2.2 1.1 0 1.5-.7 2.9-.7 1.3 0 1.7.7 2.9.7 1.2 0 2-1.1 2.7-2.1.9-1.3 1.2-2.5 1.2-2.6-.1 0-2.4-.9-2.4-3.6zM14.2 5.6c.6-.8 1-1.8.9-2.9-.9 0-2 .6-2.6 1.4-.6.7-1.1 1.7-.9 2.8 1 0 2-.5 2.6-1.3z" />
              </svg>
              <span><span className="s">Download on the</span><span className="b">App Store</span></span>
            </a>
            <a className="appstore playstore" href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M6 18a1 1 0 001 1h1v3a1.5 1.5 0 003 0v-3h2v3a1.5 1.5 0 003 0v-3h1a1 1 0 001-1V9H6v9zM3.5 9A1.5 1.5 0 002 10.5v6a1.5 1.5 0 003 0v-6A1.5 1.5 0 003.5 9zm17 0a1.5 1.5 0 00-1.5 1.5v6a1.5 1.5 0 003 0v-6A1.5 1.5 0 0020.5 9zM15.5 4l1.3-2.3a.4.4 0 00-.7-.4L14.8 3.6a6.8 6.8 0 00-5.6 0L7.9 1.3a.4.4 0 10-.7.4L8.5 4A6 6 0 006 8.6h12A6 6 0 0015.5 4zM9.5 6.6a.8.8 0 110-1.6.8.8 0 010 1.6zm5 0a.8.8 0 110-1.6.8.8 0 010 1.6z" />
              </svg>
              <span><span className="s">GET IT ON</span><span className="b">Google Play</span></span>
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer>
        <div className="wn-foot">
          <span>&copy; {new Date().getFullYear()} Joseph Miller. Advanced Bowling Tracker.</span>
          <div className="wn-foot-links">
            <a href="/">Home</a>
            <a href="/guides">Guides</a>
            <a href={TOURNAMENTS_URL} target="_blank" rel="noopener noreferrer">Tournaments</a>
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default WhatsNew;
